export const API_BASE_URL = "https://store.sharmaq.com.br/api";
export const VERSION = require("../../package.json").version;
